import './ReportSection.css';

const ReportSectionTableColumn = ({ text }) => {
  
  const lines = typeof text === 'string'
    ? text.split(/\r?\n/).map(line => line.trim()).filter(Boolean)
    : [];

  return (    
    <div className={`column has-text-left is-vcentered`}>
      <ul className="report-section-list">
        {lines.map((line, index) => (
          <li key={index}>{line}</li>
        ))}
      </ul>
    </div>    
  );
};

export default ReportSectionTableColumn;
